// class declaration
export class BomRequest {
    // variables
    public supplier_code;
    public company_code;
    public language;
    // editable variables
    public material_code;
    // support object
    public material;
    public division_code;
}



// WEBPACK FOOTER //
// ./src/app/model/bom/bom_request.model.ts